import { TABLE_PAGE_SIZE } from '../../../config';
import type { DealListFilters, DealsQueryCriteria } from '../../../modules/deals/DealsList/types';

const SCALAR_FILTER_PARAMS: Partial<Record<Exclude<keyof DealListFilters, 'phrase'>, string>> = {
  account: 'account_id__in',
  createdBy: 'created_by_user_id__in',
  exchange_deal_id: 'deal_id__in',
  status: 'status__in',
};

const RESERVED_BY_VALUE_FIELDS = new Set<string>([...Object.keys(SCALAR_FILTER_PARAMS), 'phrase']);

const appendParam = (parts: string[], key: string, value: string | null | undefined) => {
  const trimmed = value?.trim();
  if (trimmed) {
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(trimmed)}`);
  }
};

export const buildDealsQueryString = (queryCrit: DealsQueryCriteria | undefined | null): string => {
  const filters = queryCrit?.filters;
  const parts: string[] = [];

  const limit = queryCrit?.pagination?.pageSize ?? TABLE_PAGE_SIZE;
  const offset = ((queryCrit?.pagination?.pageNumber ?? 1) - 1) * limit;

  parts.push(`limit=${limit}`);
  if (offset > 0) {
    parts.push(`offset=${offset}`);
  }

  const phrase = filters?.phrase?.trim() || filters?.byPhrase?.phrase?.trim();
  if (phrase) {
    parts.push(`q=${encodeURIComponent(phrase)}`);
  }

  for (const [field, paramName] of Object.entries(SCALAR_FILTER_PARAMS) as Array<
    [keyof typeof SCALAR_FILTER_PARAMS, string]
  >) {
    appendParam(parts, paramName, filters?.[field]);
  }

  for (const filter of filters?.byValue ?? []) {
    if (RESERVED_BY_VALUE_FIELDS.has(filter.field)) continue;
    for (const value of filter.values ?? []) {
      appendParam(parts, filter.field, value);
    }
  }

  const sort = queryCrit?.sort;
  if (sort?.column) {
    const sortValue = sort.direction === 'desc' ? `-${sort.column}` : sort.column;
    parts.push(`sort=${encodeURIComponent(sortValue)}`);
  }

  return parts.join('&');
};
